// The DiscoverTile component is responsible for displaying individual items or
// services within the DiscoverSection slider. Each tile includes an image, name,
// description, and a "Find Out More" link, with clickable elements wrapped in Link
// components for navigation. Its purpose is to provide users with detailed information about
// a specific service or product, making it visually accessible and easily navigable within
// the carousel structure.

import React from 'react';
import { DiscoverData } from '.';
import Link from 'next/link';
import { useFormat } from 'helpers/hooks/useFormat';
import { CarouselContentItem } from 'types/next';
interface TileProps {
  data: CarouselContentItem;
}

const DiscoverTile: React.FC<TileProps> = ({ data }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  return (
    <div className="flex h-full flex-col items-center">
      <Link href={data?.link} className="max-h-[515px] max-w-[500px]">
        <img
          src={`https://${data?.image?.defaultHost}/i/${data?.image?.endpoint}/${data?.image?.name}`}
          alt={data.name}
          className="w-[100%] pb-15"
        />
      </Link>
      <div className="flex flex-col items-start gap-y-15 text-start">
        <h3 className="font-body text-20 font-bold leading-6">{data?.name}</h3>
        <p className="font-16 min-h-[70px] font-body font-normal leading-[19.2px] text-[#444444]">
          {data?.description}
        </p>
        <Link href={data?.link} className="underline underline-offset-[6px]">
          <h6 className="pb-6 pt-8 font-body text-16 font-bold capitalize leading-[19.2px]">
            {formatMessage({ id: 'findOut', defaultMessage: 'Find Out More' })}
          </h6>
        </Link>
      </div>
    </div>
  );
};

export default DiscoverTile;
